import { NsCaveat } from 'components/common/ns-caveat/NsCaveat';
import { useCrossSellData } from '../hooks/useCrossSellData';

export const testId = 'crossSellOfferCaveatsTestId';

export const CrossSellOfferCaveats = () => {
  const { showCaveatDetail, caveatDetail } = useCrossSellData();
  const messageKey = 'message-information';

  if (!showCaveatDetail) return null;

  return (
    <NsCaveat heading={caveatDetail?.[messageKey].title}>
      <div
        data-testid={testId}
        dangerouslySetInnerHTML={{
          __html: caveatDetail?.[messageKey]?.message
        }}
      />
    </NsCaveat>
  );
};
